// extracted by mini-css-extract-plugin
module.exports = {"marginBottomXL":"CustomMalt-Typography-marginBottomXL-c533500f","marginBottomXl":"CustomMalt-Typography-marginBottomXL-c533500f"};